module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAABCAYAAACYJC2PAAAAEElEQVQImWP8////f4YhDAD4pgP+8wFTvwAAAABJRU5ErkJggg=="